import { useEffect } from "react";
import "@/App.css";

function App() {
  useEffect(() => {
    // Redirect to the hub landing page
    window.location.replace("/hub.html");
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0a0a0a",
      color: "#FFD60A",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontSize: "14px"
    }}>
      Loading Electric Jackpot…
    </div>
  );
}

export default App;
